export class Competition {

  _id: string;
  competitionName: string;
  winningInfo:[{
    name : String,
    marks :  Number,
    grade : String,
    district : String,
}];
createdAt: Date;
releaseAt: Date;
  description: string;
  mobileDescription: string;
  fromDate: Date;
  toDate: Date;
  isActive: boolean = false;
  discountRate: number;
  dialogUsers: boolean;
  mobitelUsers: boolean;
  language: string;
  constructor(values: Object = {}) {
      Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/competition.ts